import React from "react";
import {ClipLoader} from "react-spinners";

const MyLoader = (props) => {
  const { loading } = props;

  return (
    <div id="overlay-loading" style={{ display: loading ? 'flex' : 'none'}}>
      <ClipLoader color='#ffffff' loading={loading} size={125}/>
    </div>
  );
}

export default MyLoader;
